import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { TerminalNotificationRepository } from '@app/domain/ports/tpv/terminal-notification.repository';
import { TpvTerminalNotificationResult } from '@app/domain/models/tpv/terminal-notification.model';
import { NotifyTerminalRequest } from '@app/data/dtos/tpv/terminal-notification.dto';

/** Mock del reenvío de notificación a terminal para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class TerminalNotificationMockDataSource extends TerminalNotificationRepository {
  override notify(
    idTerminal: string,
    _request: NotifyTerminalRequest,
    _idempotencyKey?: string,
  ): Observable<TpvTerminalNotificationResult> {
    return of<TpvTerminalNotificationResult>({
      idTerminal,
      data: { id_terminal: idTerminal, sent: true },
    }).pipe(delay(400));
  }
}
